import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useTotalPerformanceFeesToDate = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK ? 'totalPerformanceFeesToDate' : null,
        () => interfaceSDK!.get.getTotalPlatformPerformanceFees()
    );

    return {
        totalPerformanceFeesToDate: data,
        isLoading: !error && !data,
        error,
    };
};

export default useTotalPerformanceFeesToDate;
